import { useEffect, useState } from 'react'; 
import PageTooltip from './PageTooltip';
import pencilIcon from '../../svgs/pencil-icon.svg';

const RowEditIcon = ({ enable, onClick, icon, tooltip }) => {
    // initialize state 
    const [editIcon, setEditIcon] = useState(pencilIcon); 
    const [editTooltip, setEditTooltip] = useState('edit'); 

    useEffect(() => {
        if (icon) {
            setEditIcon(editIcon => editIcon = icon); 
        }
        else {
            setEditIcon(editIcon => editIcon = pencilIcon); 
        }
        
    }, [icon]); 

    useEffect(() => {
        if (tooltip) {
            setEditTooltip(editTooltip => editTooltip = tooltip); 
        }
        else {
            setEditTooltip(editTooltip => editTooltip = 'edit'); 
        }
    }, [tooltip]);     

    return (
        <>
            { enable ? 
            <>
                {/* show edit icon to trigger edit modal */}
                <PageTooltip title={editTooltip}>
                    <img src={editIcon} className='data-table-icon' onClick={(e)=>onClick(e)}/>
                </PageTooltip>
            </>
            // :<div style={{color: 'transparent', font: '1px'}}>-</div>}
            :<></>}
        </>
    );
}

export default RowEditIcon;